import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import ContextGeneratorUI from './ContextGeneratorUI';
import LoginPage from './LoginPage';
import ProtectedRoute from './ProtectedRoute';
import BillingPage from './BillingPage';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/billing"
          element={
            <ProtectedRoute>
              <BillingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <ContextGeneratorUI />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
